import { useId } from 'react'
// import { Input } from './ui/input'
import { cn } from '#app/utils/misc.tsx'
import { Label } from './ui/label'

export type ListOfErrors = Array<string | null | undefined> | null | undefined

export function ErrorList({
	id,
	errors,
}: {
	errors?: ListOfErrors
	id?: string
}) {
	const errorsToRender = errors?.filter(Boolean)
	if (!errorsToRender?.length) return null
	return (
		<ul id={id} className="flex flex-col gap-1">
			{errorsToRender.map(e => (
				<li key={e} className="text-[10px] text-red-500">
					{e}
				</li>
			))}
		</ul>
	)
}

type InputProps =
	| ({ type: 'textarea' } & React.ComponentProps<'textarea'>)
	| React.ComponentProps<'input'>

const inputClassName =
	'border-input bg-background ring-offset-background placeholder:text-muted-foreground focus-visible:ring-ring aria-[invalid]:border-input-invalid flex h-10 w-full border px-3 py-2 text-sm file:border-0 file:bg-transparent file:text-sm file:font-medium focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50'

const Input = function Input({
	ref,
	...props
}: InputProps & {
	ref: React.RefObject<HTMLInputElement | null>
}) {
	const className = cn(inputClassName, props.className)

	if (props.type === 'textarea') {
		return (
			<textarea
				{...(props as React.ComponentProps<'textarea'>)}
				className={className}
			/>
		)
	}

	return (
		<input
			{...(props as React.ComponentProps<'input'>)}
			className={className}
			ref={ref}
		/>
	)
}

// export function Field({
// 	labelProps,
// 	inputProps,
// 	errors,
// 	className,
// }: {
// 	labelProps: React.LabelHTMLAttributes<HTMLLabelElement>
// 	inputProps: React.InputHTMLAttributes<HTMLInputElement>
// 	errors?: ListOfErrors
// 	className?: string
// } & InputProps) {
// 	const fallbackId = useId()
// 	const id = inputProps.id ?? fallbackId
// 	const errorId = errors?.length ? `${id}-error` : undefined
// 	return (
// 		<div className={className}>
// 			<Label htmlFor={id} {...labelProps} />
// 			{({ inputProps }) => (
// 				<Input
// 					id={id}
// 					aria-invalid={errorId ? true : undefined}
// 					aria-describedby={errorId}
// 					{...inputProps}
// 				/>
// 			)}
// 			{/* <Input
// 				id={id}
// 				aria-invalid={errorId ? true : undefined}
// 				aria-describedby={errorId}
// 				{...inputProps}
// 			/> */}
// 			<div className="min-h-[32px] px-4 pb-3 pt-1">
// 				{errorId ? <ErrorList id={errorId} errors={errors} /> : null}
// 			</div>
// 		</div>
// 	)
// }

export function Field({
	ref,
	label,
	id,
	errors,
	className,
	...props
}: {
	// ref?: React.RefObject<HTMLInputElement | null>
	label: string
	// inputProps: React.InputHTMLAttributes<HTMLInputElement>
	errors?: ListOfErrors
	className?: string
} & InputProps) {
	const fallbackId = useId()
	const inputId = id ?? fallbackId
	const errorId = errors?.length ? `${id}-error` : undefined
	return (
		<FieldContainer
			className={className}
			label={label}
			id={inputId}
			// inputProps={inputProps}
			errorId={errorId}
			errors={errors}
		>
			{/* <Label htmlFor={id} {...labelProps} /> */}
			{({ inputProps }) => (
				<Input
					// @ts-expect-error
					ref={ref}
					{...props}
					aria-invalid={errorId ? true : undefined}
					aria-describedby={errorId}
					{...inputProps}
				/>
			)}
			{/* <Input
				id={id}
				aria-invalid={errorId ? true : undefined}
				aria-describedby={errorId}
				{...inputProps}
			/> */}
			{/* <div className="min-h-[32px] px-4 pb-3 pt-1">
				{errorId ? <ErrorList id={errorId} errors={errors} /> : null}
			</div> */}
		</FieldContainer>
	)
}

type FieldContainerRenderProp = (props: {
	inputProps: {
		id: string
		'aria-describedby'?: string
	}
}) => React.ReactNode

export function FieldContainer({
	className,
	id,
	label,
	// inputProps,
	children,
	errorId,
	errors,
}: {
	className?: string
	id: string
	label: string
	// inputProps: React.InputHTMLAttributes<HTMLInputElement>
	children: FieldContainerRenderProp
	errorId?: string
	errors?: ListOfErrors
}) {
	const defaultId = useId()
	const inputId = id ?? defaultId
	// const errorId = `${inputId}-error`
	// const descriptionId = `${inputId}-description`

	return (
		<div className={className}>
			<Label htmlFor={inputId}>{label}</Label>
			{children({
				inputProps: {
					id: inputId,
					'aria-describedby': errorId,
					// ...inputProps,
				},
			})}
			<div className="min-h-[32px] px-4 pb-3 pt-1">
				{errorId ? <ErrorList id={errorId} errors={errors} /> : null}
			</div>
		</div>
	)
}
